import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { COLUMN_HIGHLIGHT_CLASS } from '../../../../common/engine/utilities/constants';

const FinancialSpacer = ({ showColumnHighlight }) => {
  const cellClassNames = classnames('financial-spacer', {
    [COLUMN_HIGHLIGHT_CLASS]: showColumnHighlight,
  });

  return <td role="cell" className={cellClassNames} />;
};

FinancialSpacer.propTypes = {
  showColumnHighlight: PropTypes.bool,
};

FinancialSpacer.defaultProps = {
  showColumnHighlight: false,
};

export default FinancialSpacer;
